<template>
  <div class="c-sidebar">
    <div class="c-sidebar__header">
      <div class="c-sidebar__logo">
        <router-link to="/">
          <img src="/images/logo-ordering-website.png" />
        </router-link>
      </div>
    </div>
    <nav class="c-sidebar__nav">
      <Button v-if="!isReadOnly" :processing="processing" @onClick="onSync"
        >Sync contacts</Button
      >
      <div :class="['c-sidebar__nav', { active: isActive('organisations') }]">
        <div class="c-sidebar__nav__header">
          <router-link to="/organisations">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20 19.0002V9.27293L13.3453 3.22324C12.5825 2.52975 11.4175 2.52975 10.6547 3.22325L4.98198 8.38022C4.35656 8.94879 4 9.75481 4 10.6V19.0002C4 20.6571 5.34315 22.0002 7 22.0002H9V17C9 15.8954 9.89543 15 11 15H13C14.1046 15 15 15.8954 15 17V22.0002H17C18.6569 22.0002 20 20.6571 20 19.0002Z"
                fill="currentColor"
              />
              <path
                d="M20 9.27293H21C21 8.99119 20.8811 8.72251 20.6727 8.53299L20 9.27293ZM13.3453 3.22324L12.6727 3.96318V3.96318L13.3453 3.22324ZM10.6547 3.22325L11.3273 3.96319V3.96319L10.6547 3.22325ZM4.98198 8.38022L5.65465 9.12016H5.65465L4.98198 8.38022ZM9 22.0002V23.0002C9.55229 23.0002 10 22.5525 10 22.0002H9ZM15 22.0002H14C14 22.5525 14.4477 23.0002 15 23.0002V22.0002ZM0.327327 11.2603C-0.0813304 11.6318 -0.111447 12.2642 0.26006 12.6729C0.631567 13.0815 1.26402 13.1117 1.67267 12.7401L0.327327 11.2603ZM11.3273 3.96319C11.736 3.59168 11.7661 2.95923 11.3946 2.55057C11.0231 2.14192 10.3906 2.1118 9.98198 2.48331L11.3273 3.96319ZM20 9.27293H19C19 9.55468 19.1189 9.82335 19.3273 10.0129L20 9.27293ZM22.3273 12.7401C22.736 13.1117 23.3684 13.0815 23.7399 12.6729C24.1114 12.2642 24.0813 11.6318 23.6727 11.2603L22.3273 12.7401ZM21 5.5002C21 4.94792 20.5523 4.5002 20 4.5002C19.4477 4.5002 19 4.94792 19 5.5002H21ZM19 9.27293V19.0002H21V9.27293H19ZM12.6727 3.96318L19.3273 10.0129L20.6727 8.53299L14.018 2.4833L12.6727 3.96318ZM11.3273 3.96319C11.7087 3.61644 12.2913 3.61644 12.6727 3.96318L14.018 2.4833C12.8738 1.44306 11.1262 1.44307 9.98198 2.48331L11.3273 3.96319ZM5.65465 9.12016L11.3273 3.96319L9.98198 2.48331L4.30931 7.64028L5.65465 9.12016ZM5 10.6C5 10.0366 5.23771 9.4992 5.65465 9.12016L4.30931 7.64028C3.47541 8.39837 3 9.47306 3 10.6H5ZM5 19.0002V10.6H3V19.0002H5ZM7 21.0002C5.89543 21.0002 5 20.1048 5 19.0002H3C3 21.2093 4.79086 23.0002 7 23.0002V21.0002ZM9 21.0002H7V23.0002H9V21.0002ZM8 17V22.0002H10V17H8ZM11 14C9.34315 14 8 15.3431 8 17H10C10 16.4477 10.4477 16 11 16V14ZM13 14H11V16H13V14ZM16 17C16 15.3431 14.6569 14 13 14V16C13.5523 16 14 16.4477 14 17H16ZM16 22.0002V17H14V22.0002H16ZM17 21.0002H15V23.0002H17V21.0002ZM19 19.0002C19 20.1048 18.1046 21.0002 17 21.0002V23.0002C19.2091 23.0002 21 21.2093 21 19.0002H19ZM1.67267 12.7401L11.3273 3.96319L9.98198 2.48331L0.327327 11.2603L1.67267 12.7401ZM19.3273 10.0129L22.3273 12.7401L23.6727 11.2603L20.6727 8.53299L19.3273 10.0129ZM19 5.5002V9.27293H21V5.5002H19Z"
                fill="currentColor"
              />
            </svg>
            Organisations
          </router-link>
        </div>
        <div class="c-sidebar__nav__body">
          <router-link to="/locations">
            Locations
          </router-link>
          <router-link to="/people">
            People
          </router-link>
          <router-link to="/">
            Activity
          </router-link>
          <router-link to="/organisations/report">
            Organisation Reports
          </router-link>
        </div>
      </div>

      <div :class="['c-sidebar__nav', { active: isActive('orders') }]">
        <div class="c-sidebar__nav__header">
          <router-link to="/orders/orders">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6 2.75C5.58579 2.75 5.25 3.08579 5.25 3.5C5.25 3.91421 5.58579 4.25 6 4.25H18C18.4142 4.25 18.75 3.91421 18.75 3.5C18.75 3.08579 18.4142 2.75 18 2.75H6ZM3.25 6C3.25 5.58579 3.58579 5.25 4 5.25H20C20.4142 5.25 20.75 5.58579 20.75 6C20.75 6.41421 20.4142 6.75 20 6.75H4C3.58579 6.75 3.25 6.41421 3.25 6ZM1 10C1 8.89543 1.89543 8 3 8H21C22.1046 8 23 8.89543 23 10V22C23 23.1046 22.1046 24 21 24H3C1.89543 24 1 23.1046 1 22V10Z"
                fill="currentColor"
              />
            </svg>
            Orders
          </router-link>
        </div>
        <div class="c-sidebar__nav__body">
          <router-link to="/orders/rctis">
            RCTIs
          </router-link>
          <router-link to="/orders/reports">
            Order Reports
          </router-link>
          <router-link to="/products">
            Products
          </router-link>
        </div>
      </div>
    </nav>
    <div class="c-sidebar__footer">
      <span>Powered by: </span>
      <a href="https://diginostic.com.au" target="_blank">Diginostic</a>
    </div>
  </div>
</template>

<script>
import Button from '@/components/global/button';

export default {
  components: {
    Button
  },

  data: function() {
    return {
      processing: false
    };
  },

  props: {
    active: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    isReadOnly: function() {
      return this.$store.getters['users/isReadOnly'];
    }
  },

  methods: {
    isActive: function(path) {
      let routeName = this.$route.name;
      let orgRoutes = [
        'Organisations',
        'OrganisationsUpdate',
        'OrganisationsCreate',
        'OrganisationsDrilldown',
        'Locations',
        'LocationsUpdate',
        'LocationsCreate',
        'People',
        'PeopleUpdate',
        'PeopleCreate',
        'Notes',
        'OrganisationReport'
      ];
      let orderRoutes = [
        'Orders',
        'OrdersUpdate',
        'OrdersCreate',
        'Rctis',
        'RctisCreate',
        'RctisUpdate',
        'Products',
        'Reports'
      ];
      if (path === 'organisations') {
        if (orgRoutes.includes(routeName)) {
          return true;
        }
        return false;
      }
      if (path === 'orders') {
        if (orderRoutes.includes(routeName)) {
          return true;
        }
        return false;
      }
      return false;
    },
    async onSync() {
      this.processing = true;
      let obj = {
        action: 'sync',
        id: 1
      };
      let response = await this.$store.dispatch('leads/doAction', obj);

      this.processing = false;

      return response;
    }
  }
};
</script>

<style lang="scss">
.c-sidebar {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  margin-left: calc(var(--space-xl) * -1); // to counter the parent padding
  width: var(--sidebar-width);

  &__header {
    padding: var(--space-md) var(--space-sm) var(--space-xs);
  }

  &__logo {
    font-size: var(--font-size-xl);
    font-weight: 700;
    padding: 0 var(--space-xs);
    text-transform: uppercase;

    img {
      display: block;
      width: 100%;
    }
  }

  &__nav {
    display: flex;
    flex-direction: column;
    margin-top: var(--space-sm);
    overflow-y: hidden;

    &__header {
      position: relative;
      svg {
        position: absolute;
        left: var(--space-lg);
      }
    }

    &__body {
      height: 0;
    }

    > .btn {
      margin-left: var(--space-md);
      width: calc(100% - var(--space-md) * 2);
    }

    &-list {
      list-style: none;
      padding: 0;
    }

    .router-link-wrapper {
      margin-bottom: var(--space-xs);

      &:not(.router-link-exact-active) > a:not(.parent) {
        display: none;
      }
    }

    &.active {
      .c-sidebar__nav__header {
        a {
          background-color: var(--color-bg-4);
          border-right-color: var(--primary);
          color: var(--body-color);
          font-weight: 700;
        }
        svg {
          color: var(--primary);
        }
      }
      .c-sidebar__nav__body {
        height: 100%;
      }
    }

    a {
      border-right: transparent solid 3px;
      color: var(--body-color);
      display: block;
      padding: var(--space-xs) var(--space-sm) var(--space-xs)
        calc(var(--space-xl) + var(--space-sm));
      transition: all var(--transition-time-sm) linear;

      &:hover,
      &:active,
      &.router-link-exact-active {
        background-color: var(--color-bg-4);
        border-right-color: var(--primary);
        color: var(--body-color);
        font-weight: 700;
      }

      &:focus {
        text-decoration: none;
      }
    }
  }

  &__footer {
    align-items: center;
    bottom: var(--space-lg);
    display: inline-flex;
    font-size: var(--font-size-xxs);
    justify-content: center;
    margin: auto 0 0;
    position: fixed;
    text-align: center;
    width: var(--sidebar-width);

    a {
      background-image: url('/images/logo-diginostic.svg');
      background-repeat: no-repeat;
      background-size: contain;
      content: '';
      display: block;
      height: 1.0625rem;
      margin-left: var(--space-xs);
      width: 4.5rem;

      // hide text
      overflow: hidden;
      text-indent: 101%;
      white-space: nowrap;
    }
  }
}
</style>
